import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@services/baseQuery';
import { IFAPILogs } from '../../modules/front-office/interface/fo-logs.interface';
import { handleError } from '../../utils/api-error-handling';

export const logsApi = createApi({
  reducerPath: 'logsApi',
  baseQuery: baseQuery,
  tagTypes: ['Logs'],
  endpoints: (builder) => ({
    getAllLogs: builder.query({
      query: (params) => {
        return `logs?${params || ''}`;
      },
      providesTags: ['Logs'],
      transformErrorResponse: async (baseQueryReturnValue) => {
        return handleError(baseQueryReturnValue);
      },
      transformResponse: async (response: IFAPILogs) => {
        return response.data.logs.map(({ log }, id) => ({ ...log, id }));
      },
      forceRefetch() {
        return true;
      },
      keepUnusedDataFor: 0.0001,
    }),
    getLogsByFolio: builder.query({
      query: (folioId) => {
        return `logs/${folioId}`;
      },
      providesTags: ['Logs'],
      transformErrorResponse: async (baseQueryReturnValue) => {
        return handleError(baseQueryReturnValue);
      },
      transformResponse: async (response: IFAPILogs) => {
        return response.data.logs.map(({ log }, id) => ({ ...log, id }));
      },
      forceRefetch() {
        return true;
      },
      keepUnusedDataFor: 0.0001,
    }),
  }),
});

export const {
  useLazyGetAllLogsQuery,
  useGetAllLogsQuery,
  useLazyGetLogsByFolioQuery,
  useGetLogsByFolioQuery,
} = logsApi;
